<template>
  <div class="container">
    <!-- COPY OF UNIVERSAL LOGIN/PASSWORD RESET HEADER (AUTH0) HTML -->
    <div class="page-nav">
      <a href="https://www.mikmak.com">
        <img src="https://attach-videos.s3.amazonaws.com/mikmak-logo-teal.png" />
      </a>
      <div class="nav-links">
        <label>
          <a href="https://www.mikmak.com/#our-software">Software</a>
        </label>
        <label>
          <a href="https://www.mikmak.com/#our-solutions">Solutions</a>
        </label>
        <label>
          <a href="https://www.mikmak.com/#our-services">Services</a>
        </label>
        <label>
          <a href="https://www.mikmak.com/join">Careers</a>
        </label>
        <label>
          <a href="https://www.mikmak.com/aboutus_0">About</a>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style scoped>
.container {
  font-family: Lato;
  position: absolute;
  left: 0;
  right: 0;
}

/* COPY OF UNIVERSAL LOGIN/PASSWORD RESET HEADER (AUTH0) CSS */
.page-nav {
  position: relative;
  height: 50px;
  box-shadow: 0 2px 2px rgb(0 0 0 / 9%);
  padding: 0px 16px;
  z-index: 10000000;
}

.page-nav img {
  position: absolute;
  top: 12px;
  width: 60px;
  left: 16px;
}

.page-nav label {
  margin-right: 24px;
  height: 92px;
  align-items: center;
  transform: translateY(1px);
  transition: color .15s ease-in-out;
  letter-spacing: .5px;
  font-size: 16px;
}

.page-nav label a {
  color: #1d2229!important;
  text-decoration: none;
  cursor: pointer;
}

.nav-links {
  padding-top: 15px;
  display: flex;
  justify-content: center;
}

.nav-links span {
  margin-right: 24px;
}

@media only screen and (max-width: 600px) {
  .nav-links {
    display: none;
  }
}
</style>
